export default function formatNumber(num: number): string {
    // Проверка специальных значений
    if (!isFinite(num)) return num.toString()

    const parts = num.toString().split('.')
    let integerPart = parts[0]
    const fractionalPart = parts[1] || ''

    // Обработка отрицательных чисел
    const hasMinus = integerPart.startsWith('-')
    if (hasMinus) integerPart = integerPart.slice(1)

    // Форматирование целой части с пробелами
    let formattedInteger = ''
    for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
        if (count > 0 && count % 3 === 0) {
            formattedInteger = ' ' + formattedInteger
        }
        formattedInteger = integerPart[i] + formattedInteger
    }

    // Сборка результата
    return (hasMinus ? '-' : '') + formattedInteger + (fractionalPart ? '.' + fractionalPart : '')
}
